import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import VinculacioView from './components/VinculacioView';
import Callback from './components/Callback';
import SuccessfulPage from './components/SuccessfulPage';
import OnboardingFinish from './components/OnboardingFinish';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<VinculacioView />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/success" element={<SuccessfulPage />} />
        <Route path="/onboarding-finish" element={<OnboardingFinish />} />
      </Routes>
    </Router>
  );
}

export default App;
